import { Box, Grid, Typography } from "@mui/material";
import React from "react";

const AllTopicsList = ({ topics }) => {
    const attachments = [
        { label: "Topic Notes", src: topics?.topic_pdfPath },
        { label: "Level 1 Practice", src: topics?.level1_practicePdf },
        { label: "Level 2 Practice", src: topics?.level2_practicePdf },
        { label: "Level 3 Practice", src: topics?.level3_practicePdf },
    ].filter(item => item.src);
    return (
        <Box id="attachment-modal-description" sx={{ width: "100%", mt: 2 }}>
            <Grid container spacing={3}>
                {attachments.length > 0 ? (
                    attachments.map((item, index) => (
                        <Grid item xs={12} sm={6} md={3} key={index}>
                            <Box sx={{ textAlign: "center" }}>
                                <div
                                    style={{
                                        position: "relative",
                                        cursor: item.src ? "pointer" : "not-allowed",
                                        border: "1px solid #ccc",
                                        borderRadius: "4px",
                                        marginBottom: 10,
                                        overflow: "hidden",
                                        opacity: item.src ? 1 : 0.5,
                                    }}
                                    onClick={() => item?.src && window.open(item.src, "_blank", "noopener,noreferrer")}
                                >
                                    {item.src ? (
                                        <iframe
                                            src={item.src}
                                            width="100%"
                                            title={`${item.label} Viewer`}
                                            style={{
                                                pointerEvents: "none",
                                                border: "none",
                                                overflow: "hidden",
                                                scrollbarWidth: "none",
                                            }}
                                        />
                                    ) : (
                                        <Typography variant="body2" color="textSecondary">
                                            Not Available
                                        </Typography>
                                    )}
                                </div>
                                <Typography>{item?.label}</Typography>
                            </Box>
                        </Grid>
                    ))
                ) : (
                    <Typography sx={{ textAlign: "center", width: "100%", mt: 2 }} color="error">
                        No Attachments Available
                    </Typography>
                )}
            </Grid>
        </Box>
    );
};

export default AllTopicsList;
